// VX: bundle "Elige un Pack y Ahorra". Talla por unidad, "Elegir" otro modelo y añadir el pack completo al carrito.
if (!customElements.get('vx-bundle')) {
  customElements.define(
    'vx-bundle',
    class VxBundle extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;
        try {
          this.data = JSON.parse(this.querySelector('[data-vx-bundle-data]').textContent);
        } catch (e) {
          return;
        }
        this.byHandle = {};
        this.data.products.forEach((p) => (this.byHandle[p.handle] = p));
        this.current = this.byHandle[this.data.current];
        this.moneyFormat = this.dataset.money || '${{amount}}';
        this.opts = Array.from(this.querySelectorAll('.vx-bundle__opt'));
        this.units = [{ handle: this.data.current, variantId: Number(this.dataset.currentVariant) }];
        this.pickerFor = null;

        this.opts.forEach((opt) => {
          opt.addEventListener('click', (e) => {
            if (e.target.closest('select, button, .vx-bundle__units')) return;
            this.select(Number(opt.dataset.index));
          });
          opt.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              this.select(Number(opt.dataset.index));
            }
          });
        });

        const def = Number(this.dataset.default) || 1;
        this.select(this.opts.some((o) => Number(o.dataset.index) === def) ? def : Number(this.opts[0].dataset.index));
        this.startTimer();
        this.hookAddToCart();
        // Con nombre dentro de cada unidad, los campos de nombre sueltos no se usan (ni se exigen)
        if (this.dataset.unitNames === 'true') {
          const scope = this.closest('product-info') || this.closest('section') || document;
          scope.querySelectorAll('.vx-nf').forEach((box) => {
            box.hidden = true;
            box.querySelectorAll('input').forEach((el) => (el.disabled = true));
          });
        }
        this.followVariantPicker();
      }

      // La 1ª unidad del pack sigue el color/talla elegidos en el selector de arriba
      followVariantPicker() {
        if (typeof subscribe !== 'function' || !window.PUB_SUB_EVENTS) return;
        subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const v = event.data && event.data.variant;
          if (!v || event.data.sectionId !== this.dataset.section || !this.isConnected) return;
          if (!this.current || !this.current.variants.some((x) => x.id === v.id)) return;
          this.units[0] = { handle: this.data.current, variantId: v.id };
          this.renderUnits();
          this.updatePrices();
        });
      }

      money(cents) {
        const n = (cents / 100).toFixed(2);
        return this.moneyFormat
          .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, n.replace('.', ','))
          .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
          .replace(/\{\{\s*amount\s*\}\}/, n);
      }

      variantOf(unit) {
        const p = this.byHandle[unit.handle];
        return p ? p.variants.find((v) => v.id === unit.variantId) : null;
      }

      firstAvailable(p) {
        return p.variants.find((v) => v.available) || p.variants[0];
      }

      select(index) {
        this.selected = this.opts.find((o) => Number(o.dataset.index) === index);
        const qty = Number(this.selected.dataset.qty);
        // Con desplegables por opción cada unidad sale ya rellena (mismo modelo que la 1ª) para elegir color y talla
        const split = this.dataset.split === 'true';
        while (this.units.length < qty) {
          const idx = this.units.length;
          const partner = idx === 1 ? this.partnerUnit() : null;
          this.units.push(partner || (split ? { handle: this.units[0].handle, variantId: this.units[0].variantId } : null));
        }
        this.opts.forEach((o) => {
          const on = o === this.selected;
          o.classList.toggle('is-selected', on);
          o.setAttribute('aria-checked', on ? 'true' : 'false');
          o.querySelector('[data-units]').innerHTML = '';
        });
        this.renderUnits();
        this.updatePrices();
      }

      renderUnits() {
        const box = this.selected.querySelector('[data-units]');
        const qty = Number(this.selected.dataset.qty);
        box.innerHTML = '';
        for (let i = 0; i < qty; i++) {
          const unit = this.units[i];
          const row = document.createElement('div');
          row.className = 'vx-bundle__unit';
          if (unit) {
            const p = this.byHandle[unit.handle];
            const img = document.createElement('img');
            img.className = 'vx-bundle__unit-img';
            img.src = p.image || '';
            img.alt = '';
            img.width = 60;
            img.height = 75;
            const col = document.createElement('div');
            col.className = 'vx-bundle__unit-info';
            const title = document.createElement('p');
            title.className = 'vx-bundle__unit-title';
            title.textContent = this.dataset.split === 'true' ? this.shortTitle(p.title) : p.title;
            col.appendChild(title);
            const controls = document.createElement('div');
            controls.className = 'vx-bundle__unit-controls';
            const split = this.dataset.split === 'true';
            if (split) this.renderProductSelect(controls, unit, i);
            if (split && p.variants.length > 1 && (p.options || []).length) {
              // Un desplegable por opción (p. ej. Color y Talla)
              this.renderOptionSelects(controls, p, unit, i);
            } else if (p.variants.length > 1) {
              const sel = document.createElement('select');
              sel.className = 'vx-bundle__select';
              sel.setAttribute('aria-label', 'Talla ' + (i + 1));
              p.variants.forEach((v) => {
                const o = document.createElement('option');
                o.value = v.id;
                o.textContent = v.title + (v.available ? '' : ' (agotado)');
                o.disabled = !v.available;
                if (v.id === unit.variantId) o.selected = true;
                sel.appendChild(o);
              });
              sel.addEventListener('change', () => {
                unit.variantId = Number(sel.value);
                this.updatePrices();
              });
              controls.appendChild(sel);
            }
            if (this.dataset.unitNames === 'true') this.renderNameInput(controls, unit, i);
            if (i > 0 && !split) {
              const ch = document.createElement('button');
              ch.type = 'button';
              ch.className = 'vx-bundle__choose';
              ch.textContent = this.dataset.choose || 'Elegir';
              ch.addEventListener('click', () => this.openPicker(i));
              controls.appendChild(ch);
            }
            col.appendChild(controls);
            row.appendChild(img);
            row.appendChild(col);
          } else {
            const plus = document.createElement('button');
            plus.type = 'button';
            plus.className = 'vx-bundle__plus';
            plus.setAttribute('aria-label', (this.dataset.choose || 'Elegir') + ' ' + (i + 1));
            plus.innerHTML = '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><circle cx="12" cy="12" r="11" fill="#121212"/><path d="M12 7v10M7 12h10" stroke="#fff" stroke-width="2.4" stroke-linecap="round"/></svg>';
            plus.addEventListener('click', () => this.openPicker(i));
            const ch = document.createElement('button');
            ch.type = 'button';
            ch.className = 'vx-bundle__choose';
            ch.textContent = this.dataset.choose || 'Elegir';
            ch.addEventListener('click', () => this.openPicker(i));
            row.classList.add('is-empty');
            row.appendChild(plus);
            row.appendChild(ch);
          }
          box.appendChild(row);
        }
      }

      // 2.ª unidad con otro modelo preseleccionado (ajuste "handle-actual=handle-pareja|...")
      partnerUnit() {
        const map = {};
        (this.dataset.unit2Map || '').split('|').forEach((pair) => {
          const [a, b] = pair.split('=').map((x) => (x || '').trim());
          if (a && b) map[a] = b;
        });
        const p = this.byHandle[map[this.data.current]];
        if (!p) return null;
        const first = this.variantOf(this.units[0]);
        // Misma talla (última opción) si existe y está disponible
        let v = first && p.variants.find((x) => x.available && x.options[x.options.length - 1] === first.options[first.options.length - 1]);
        if (!v) v = this.firstAvailable(p);
        return v ? { handle: p.handle, variantId: v.id } : null;
      }

      // Nombre corto: lo que va entre comillas (“MI HIJO, MI ORGULLO” — Pulsera… → MI HIJO, MI ORGULLO)
      shortTitle(title) {
        const m = String(title).match(/[“"«]([^”"»]+)[”"»]/);
        return m ? m[1].trim() : title;
      }

      // Desplegable con los modelos de la colección (p. ej. "A mi hombre" / "A mi hijo") para cada unidad
      renderProductSelect(controls, unit, i) {
        const list = this.data.products.filter((x) => x.handle === unit.handle || x.variants.some((v) => v.available));
        if (list.length < 2) return;
        const sel = document.createElement('select');
        sel.className = 'vx-bundle__select vx-bundle__select--product';
        sel.setAttribute('aria-label', (this.dataset.productLabel || 'Modelo') + ' ' + (i + 1));
        list.forEach((x) => {
          const o = document.createElement('option');
          o.value = x.handle;
          o.textContent = this.shortTitle(x.title);
          if (x.handle === unit.handle) o.selected = true;
          sel.appendChild(o);
        });
        sel.addEventListener('change', () => {
          const p = this.byHandle[sel.value];
          const prev = this.variantOf(unit);
          // Mantiene color y talla si existen en el nuevo modelo
          let v = prev && p.variants.find((x) => x.available && x.title === prev.title);
          if (!v && prev) v = p.variants.find((x) => x.available && x.options[x.options.length - 1] === prev.options[prev.options.length - 1]);
          if (!v) v = this.firstAvailable(p);
          unit.handle = p.handle;
          unit.variantId = v.id;
          this.renderUnits();
          this.updatePrices();
        });
        controls.appendChild(sel);
      }

      // Nombre a grabar en esta unidad (se guarda en el pedido como propiedad del artículo)
      renderNameInput(controls, unit, i) {
        const input = document.createElement('input');
        input.type = 'text';
        input.className = 'vx-bundle__name-input';
        input.placeholder = this.dataset.namePlaceholder || 'Nombre';
        input.maxLength = Number(this.dataset.nameMax) || 20;
        input.autocomplete = 'off';
        input.setAttribute('aria-label', (this.dataset.nameLabel || 'Nombre') + ' ' + (i + 1));
        input.value = unit.name || '';
        input.addEventListener('input', () => {
          unit.name = input.value;
          input.classList.remove('is-error');
        });
        controls.appendChild(input);
      }

      renderOptionSelects(controls, p, unit, i) {
        const current = p.variants.find((v) => v.id === unit.variantId) || this.firstAvailable(p);
        const selects = p.options.map((name, idx) => {
          const sel = document.createElement('select');
          sel.className = 'vx-bundle__select';
          sel.setAttribute('aria-label', name + ' ' + (i + 1));
          const values = [];
          p.variants.forEach((v) => {
            if (!values.includes(v.options[idx])) values.push(v.options[idx]);
          });
          values.forEach((val) => {
            const o = document.createElement('option');
            o.value = val;
            // Agotado si no hay ninguna variante disponible con este valor y las demás opciones elegidas
            const ok = p.variants.some(
              (v) => v.available && v.options[idx] === val && v.options.every((x, j) => j === idx || x === current.options[j])
            );
            o.textContent = val + (ok ? '' : ' (agotado)');
            if (val === current.options[idx]) o.selected = true;
            sel.appendChild(o);
          });
          controls.appendChild(sel);
          return sel;
        });
        selects.forEach((sel, idx) => {
          sel.addEventListener('change', () => {
            const wanted = selects.map((s) => s.value);
            // Variante exacta; si no existe, la primera disponible con el valor que se acaba de cambiar
            let v = p.variants.find((x) => x.options.every((val, j) => val === wanted[j]));
            if (!v) v = p.variants.find((x) => x.available && x.options[idx] === wanted[idx]) || p.variants.find((x) => x.options[idx] === wanted[idx]);
            if (!v) return;
            unit.variantId = v.id;
            this.renderUnits();
            this.updatePrices();
          });
        });
      }

      openPicker(i) {
        this.pickerFor = i;
        const dlg = this.querySelector('[data-picker]');
        const grid = this.querySelector('[data-picker-grid]');
        grid.innerHTML = '';
        this.data.products.forEach((p) => {
          if (!p.variants.some((v) => v.available)) return;
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'vx-bundle-picker__item';
          b.innerHTML = '<img alt="" loading="lazy"><span></span>';
          b.querySelector('img').src = p.image || '';
          b.querySelector('span').textContent = p.title;
          b.addEventListener('click', () => {
            const prevVariant = this.units[0] ? this.variantOf(this.units[0]) : null;
            let v = this.firstAvailable(p);
            if (prevVariant) {
              const same = p.variants.find((x) => x.available && x.title === prevVariant.title);
              if (same) v = same;
            }
            this.units[this.pickerFor] = { handle: p.handle, variantId: v.id };
            dlg.close();
            this.renderUnits();
            this.updatePrices();
          });
          grid.appendChild(b);
        });
        dlg.showModal();
      }

      // Unidades que se añaden: los huecos sin elegir usan el mismo modelo y talla que la 1ª
      resolvedUnits() {
        const qty = Number(this.selected.dataset.qty);
        const out = [];
        for (let i = 0; i < qty; i++) {
          out.push(this.units[i] || { handle: this.units[0].handle, variantId: this.units[0].variantId });
        }
        return out;
      }

      updatePrices() {
        this.opts.forEach((o) => {
          const qty = Number(o.dataset.qty);
          const pct = Number(o.dataset.pct) || 0;
          // Igual que Shopify: el descuento se calcula por unidad y se trunca al céntimo
          // (p. ej. 2 × $29.95 al 5% = $56.92; 2 × $54.95 al 10% = $98.92)
          let sum = 0;
          let regular = 0;
          for (let i = 0; i < qty; i++) {
            const u = (o === this.selected && this.units[i]) || this.units[0];
            const v = this.variantOf(u);
            if (!v) continue;
            // Precio real: el tachado si se muestra (y es mayor), si no el precio normal
            regular += o.querySelector('[data-compare]') && v.compare > v.price ? v.compare : v.price;
            sum += v.price - Math.floor((v.price * pct) / 100);
          }
          // Precio fijo del pack (p. ej. 2 por $49.95): sustituye al porcentaje
          const fixed = Number(o.dataset.fixed) || 0;
          if (fixed > 0) {
            sum = fixed;
            const saveEl = o.querySelector('[data-save]');
            if (saveEl) {
              saveEl.hidden = regular - fixed <= 0;
              saveEl.textContent = 'Ahorras ' + this.money(regular - fixed);
            }
          }
          o.querySelector('[data-price]').textContent = this.money(sum);
          // Precio de comparación tachado (solo existe si el bloque lo activa)
          const cmpEl = o.querySelector('[data-compare]');
          if (cmpEl) {
            let cmp = 0;
            for (let i = 0; i < qty; i++) {
              const v = this.variantOf((o === this.selected && this.units[i]) || this.units[0]);
              if (v) cmp += v.compare > v.price ? v.compare : v.price;
            }
            cmpEl.hidden = cmp <= sum;
            cmpEl.textContent = this.money(cmp);
          }
        });
      }

      startTimer() {
        const el = this.querySelector('.vx-bundle__timer');
        if (!el) return;
        const end = Number(el.dataset.end) * 1000;
        const out = el.querySelector('[data-vx-timer]');
        const pad = (n) => String(n).padStart(2, '0');
        // Modo bucle: N minutos desde que se abre la página; al llegar a 0 vuelve a empezar
        if (el.dataset.loop) {
          const span = Number(el.dataset.loop) * 60000;
          const start = Date.now();
          const loopTick = () => {
            const d = span - ((Date.now() - start) % span);
            if (out) out.textContent = pad(Math.floor(d / 60000)) + ':' + pad(Math.floor((d % 60000) / 1000));
          };
          loopTick();
          setInterval(loopTick, 1000);
          return;
        }
        // Cada día la oferta cambia a las 00:00 de Puerto Rico (UTC-4): se cuenta hasta esa medianoche
        // (o hasta el fin real si es antes) y el contador desaparece en el fin real.
        const pr = 4 * 3600000;
        const tick = () => {
          const now = Date.now();
          if (end - now <= 0) {
            el.hidden = true;
            clearInterval(t);
            return;
          }
          const nextMidnight = (Math.floor((now - pr) / 86400000) + 1) * 86400000 + pr;
          const d = Math.min(end, nextMidnight) - now;
          if (out) out.textContent = pad(Math.floor(d / 3600000)) + ':' + pad(Math.floor((d % 3600000) / 60000)) + ':' + pad(Math.floor((d % 60000) / 1000));
        };
        tick();
        const t = setInterval(tick, 1000);
      }

      hookAddToCart() {
        const section = this.closest('section') || document;
        const form = section.querySelector('product-form form[action*="/cart/add"]');
        if (!form) return;
        this.form = form;
        // Captura en el documento: se ejecuta ANTES que el envío normal de Dawn (que solo añadiría 1 unidad)
        document.addEventListener(
          'submit',
          (e) => {
            if (e.target !== this.form || !this.isConnected) return;
            e.preventDefault();
            e.stopImmediatePropagation();
            this.addToCart();
          },
          true
        );
      }

      addToCart() {
        if (this.busy) return;
        const units = this.resolvedUnits();
        const err = this.querySelector('[data-error]');
        err.hidden = true;
        const unitNames = this.dataset.unitNames === 'true';
        // Nombre obligatorio en cada unidad del pack (solo si el bloque lo exige)
        if (unitNames && this.dataset.nameRequired !== 'false') {
          const inputs = Array.from(this.selected.querySelectorAll('.vx-bundle__name-input'));
          const missing = inputs.filter((el) => el.value.trim() === '');
          if (missing.length) {
            missing.forEach((el) => el.classList.add('is-error'));
            err.textContent = this.dataset.nameError || 'Escribe el nombre de cada pulsera.';
            err.hidden = false;
            missing[0].focus();
            return;
          }
        }
        // Propiedades del formulario (p. ej. "Su Nombre" / "Tu Nombre") en cada artículo del pack
        // Las fotos subidas (archivos) van aparte: no se pueden mandar en JSON
        const properties = {};
        const files = {};
        new FormData(this.form).forEach((value, key) => {
          const m = key.match(/^properties\[(.+)\]$/);
          if (!m) return;
          if (value instanceof File) {
            if (value.size) files[m[1]] = value;
          } else if (String(value).trim() !== '') properties[m[1]] = value;
        });
        // Una línea por variante y nombre (unidades iguales se agrupan)
        const lines = {};
        units.forEach((u) => {
          const props = Object.assign({}, properties);
          const name = (u.name || '').trim();
          if (unitNames && name) props[this.dataset.nameLabel || 'Nombre'] = name;
          const key = u.variantId + '|' + JSON.stringify(props);
          if (!lines[key]) lines[key] = { id: Number(u.variantId), quantity: 0, props };
          lines[key].quantity += 1;
        });
        const items = Object.values(lines).map((l) => {
          const item = { id: l.id, quantity: l.quantity };
          if (Object.keys(l.props).length) item.properties = l.props;
          return item;
        });
        const btn = this.form.querySelector('button[name="add"]');
        this.busy = true;
        if (btn) {
          btn.classList.add('loading');
          btn.setAttribute('aria-disabled', 'true');
        }
        const drawer = document.querySelector('cart-drawer');
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        const sections = ['cart-drawer', 'cart-icon-bubble'];
        const post = (body, json) =>
          fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: json ? { 'Content-Type': 'application/json', Accept: 'application/json' } : { Accept: 'application/json' },
            body: body,
          }).then((r) => r.json());
        const postJson = (list) => post(JSON.stringify({ items: list, sections: sections, sections_url: window.location.pathname }), true);
        let request;
        if (Object.keys(files).length) {
          // 1ª línea con la foto (formulario multipart); Shopify devuelve el enlace del archivo y se reutiliza en el resto
          const first = items[0];
          const rest = items.slice(1);
          const fd = new FormData();
          fd.append('id', first.id);
          fd.append('quantity', first.quantity);
          Object.keys(first.properties || {}).forEach((k) => fd.append('properties[' + k + ']', first.properties[k]));
          Object.keys(files).forEach((k) => fd.append('properties[' + k + ']', files[k], files[k].name));
          if (!rest.length) {
            fd.append('sections', sections.join(','));
            fd.append('sections_url', window.location.pathname);
          }
          request = post(fd, false).then((data) => {
            if (data.status || !rest.length) return data;
            const urls = {};
            Object.keys(files).forEach((k) => {
              if (data.properties && data.properties[k]) urls[k] = data.properties[k];
            });
            rest.forEach((it) => (it.properties = Object.assign({}, it.properties, urls)));
            return postJson(rest);
          });
        } else {
          request = postJson(items);
        }
        request
          .then((data) => {
            if (data.status) {
              err.textContent = data.description || data.message || 'No se pudo añadir al carrito.';
              err.hidden = false;
              return;
            }
            if (window.publish && window.PUB_SUB_EVENTS) {
              window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'vx-bundle', cartData: data });
            }
            if (drawer && typeof drawer.renderContents === 'function') {
              drawer.classList.remove('is-empty');
              drawer.renderContents(data);
            } else {
              window.location.href = root + 'cart';
            }
          })
          .catch(() => {
            err.textContent = 'No se pudo añadir al carrito. Inténtalo de nuevo.';
            err.hidden = false;
          })
          .finally(() => {
            this.busy = false;
            if (btn) {
              btn.classList.remove('loading');
              btn.removeAttribute('aria-disabled');
            }
          });
      }
    }
  );
}
